import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";

export function UserMenu() {
  const auth = useAuth();
  const { t } = useTranslation();

  if (!auth.isAuthenticated || !auth.user) {
    return (
      <button
        type="button"
        onClick={() => void auth.signinRedirect()}
        className="rounded-pill bg-white/10 px-4 py-1.5 text-xs font-semibold text-white hover:bg-white/20 transition-colors"
      >
        {t("auth.signIn")}
      </button>
    );
  }

  const profile = auth.user.profile as {
    name?: string;
    preferred_username?: string;
    email?: string;
  };
  const display = profile.name ?? profile.preferred_username ?? profile.email ?? "—";
  const initials = display
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  return (
    <div className="flex items-center gap-3">
      <div className="text-right hidden md:block">
        <div className="text-xs font-semibold text-white">{display}</div>
      </div>
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-pantera-500 to-accent-500 text-xs font-bold text-white">
        {initials || "U"}
      </div>
      <button
        type="button"
        onClick={() =>
          void auth.signoutRedirect({
            post_logout_redirect_uri: window.location.origin,
          })
        }
        className="rounded-pill bg-white/10 px-3 py-1.5 text-xs font-medium text-white hover:bg-white/20 transition-colors"
      >
        {t("auth.signOut")}
      </button>
    </div>
  );
}
